import { useContext } from 'react';
import {
  UNSAFE_NavigationContext,
  useNavigate,
  UNSAFE_DataRouterContext,
  useLocation,
} from 'react-router';
import type {
  QueryParamAdapter,
  QueryParamAdapterComponent,
} from 'use-query-params';

// Stolen from https://github.com/pbeshai/use-query-params/blob/b14c97ec2e7b1dfaca51d4d17439f9c306b34dba/packages/use-query-params-adapter-react-router-6/src/index.ts
// with updates to add preventScrollReset
export const ReactRouter6Adapter: QueryParamAdapterComponent = ({
  children,
}) => {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const navigate = useNavigate();
  const router = useContext(UNSAFE_DataRouterContext)?.router;
  const location = useLocation();

  const adapter: QueryParamAdapter = {
    replace(newLocation) {
      navigate(newLocation.search || '?', {
        replace: true,
        state: newLocation.state,
        preventScrollReset: true,
      });
    },
    push(newLocation) {
      navigate(newLocation.search || '?', {
        replace: false,
        state: newLocation.state,
        preventScrollReset: true,
      });
    },
    // eslint-disable-next-line no-restricted-syntax
    get location() {
      return (
        router?.state?.location ?? (navigator as any)?.location ?? location
      );
    },
  };

  return children(adapter);
};
